import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {i18n} from '../../../translate/i18n'
import {Loading} from '../../../components/Loading/Loading'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {Input} from '../../../components/Input/Input'
import {Button} from '../../../components/Button/Button'
import {useNavigate, useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import {GET, PATCH, POST} from '../../../services/api'
import useAuth from '../../../hooks/useAuth'
import {Datatable} from '../../../components/Datatable/Datatable'
import moment from 'moment'

type CupomType =
  | 'classification'
  | 'product'
  | 'individuality'
  | 'exclusive'
  | 'quantitative'
  | 'periodical'
  | 'cupomDay'

type UserType = {
  id: number
  image: string
  name: string
  email: string
  type: string
  created: string
  status: boolean
  cpf: string
}

type DiscountCoupon = {
  id: number
  nameCoupom: string
  description: string
  typeCupom: CupomType
  valueDiscount?: number
  percentageDiscount?: number
  usageQuantity?: number
  startDate: string
  endDate: string
  created?: Date | null
  updated?: Date | null
  status: boolean
  idCatalog?: number | null
  sellerId?: number | null
  pluginspaceId?: number
  listClassifications?: number[]
  listProducts?: number[]
  daysValidity?: number
}

type CupomData = {
  id: number
  nameCoupom: string
  description: string
  typeCupom: string
  pluginspaceId: number
  valueDiscount: string
  percentageDiscount: string
  usageQuantity: number
  startDate: string
  endDate: string
  created: string
  updated: string
  deleted: null
  status: boolean
  idCatalog?: number
  listClassifications?: number[]
  listProducts?: number[]
  sellerId?: number
  daysValidity?: number
}

type TypeListProduct = {
  id: string
  name: string
  code: string
  price: string
  image: string
  sellerId: string
  allowDiscount: boolean
  sellerCatalog: boolean
}

type OrderType = {
  field: string
  type: 'ASC' | 'DESC'
}

type MetaType = {
  hasNextPage: boolean
  hasPreviousPage: boolean
  itemCount: number
  page: number
  pageCount: number
  take: number
}

const PageContent: FC = () => {
  const {id} = useParams()

  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const [name, setName] = useState('')
  const [description, setDescription] = useState('')

  const [startDate, setStartDate] = useState('')
  const [finishDate, setFinishDate] = useState('')

  const [value, setValue] = useState<string | number>('0')
  const [usageQuantity, setUsageQuantity] = useState(1)
  const [type, setType] = useState<'monetary' | 'percentage'>('monetary')

  const [typeCupom, settypeCupom] = useState<CupomType>('quantitative')

  const [statusCupom, setStatusCupom] = useState<boolean>(true)

  const [classification, setClassification] = useState<number[]>([])
  const [classificationOptions, setClassificationOptions] = useState<
    {
      value: number
      name: string
    }[]
  >([])

  const [seller, setSeller] = useState<number>(0)
  const [sellerOptions, setSellerOptions] = useState<any[]>([])

  const [catalog, setCatalogs] = useState<number>(0)
  const [catalogsOptions, setCatalogsOptions] = useState<any[]>([])

  const [days, setDays] = useState<number[]>([])

  const [hasErrorCatalog, setHasErrorCatalog] = useState(false)
  const [hasErrorSeller, setHasErrorSeller] = useState(false)

  const [listProducts, setListProducts] = useState<TypeListProduct[]>([])
  const [loadingComp, setLoadingComp] = useState(false)
  const [listsearchproducts, setListSearchProducts] = useState<TypeListProduct[]>([])
  const [searchproduct, setSearchProduct] = useState('')
  const [meta, setMeta] = useState<MetaType | undefined>(undefined)

  const {loginInfo} = useAuth()

  async function getSellers() {
    try {
      const usersRes = await GET(`/users`)
        .then((res) => {
          return res
        })
        .catch((error) => {
          setHasErrorSeller(true)
          Swal.fire({
            icon: 'warning',
            title: 'Atenção.',
            text: 'Não foi possível recuperar dados de vendedores, para listagem!',
          })
          return
        })
      const newUsers = usersRes.data
        .filter((user: UserType) => user.type === 'seller' && user.status === true)
        .map((user: UserType) => {
          return {
            value: user.id,
            select: user.name,
          }
        })
      setSellerOptions(newUsers)
    } catch (error) {
      setHasErrorSeller(true)
    }
  }

  async function getClassification() {
    try {
      const res = await GET(`/classification`)
      const news = res.data
        .filter((row: any) => row.status)
        .map((row: any) => {
          return {
            value: row.id,
            name: `${row.code} - ${row.name}`,
          }
        })
      setClassificationOptions(news)
    } catch (error) {}
  }

  async function getCatalogs() {
    try {
      const res = await GET(`/catalog/getAllCatalogsList`)
        .then((res) => {
          return res
        })
        .catch((error) => {
          setHasErrorCatalog(true)
          Swal.fire({
            icon: 'warning',
            title: 'Atenção.',
            text: 'Não foi possível recuperar dados de catalogos, para listagem!',
          })
          return
        })

      const news = res.data.map((row: any) => {
        return {
          value: row.id,
          select: row.catalog,
        }
      })
      setCatalogsOptions(news)
    } catch (error) {
      setHasErrorCatalog(true)
    }
  }

  const searchProduct = async (
    take: number = 200,
    page: number = 1,
    search: string = '',
    order: OrderType = {field: 'name', type: 'ASC'}
  ) => {
    try {
      if ((!searchproduct.trim() && !search.trim()) || search.length < 3) {
        let text = 'Informe o nome do produto, antes de pesquisa!'
        if (search.length < 3) {
          text = 'Informe no mínimo 3 caracteres para pesquisa!'
        }

        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: text,
        })
        return
      }
      let res
      if (!search.trim()) {
        setLoadingComp(true)
        res = await POST(
          `/product/productFilterCatalogCupons?order=ASC&page=${page}&take=${take}`,
          {
            name: searchproduct,
            isInventoryGreaterThan: 1,
          }
        )
      } else {
        setLoadingComp(true)
        if (listsearchproducts.length > 0) {
          /**
           * Perquisar produtos usando o array carregado listsearchproducts
           * usando o campo search
           */
          const resFilter = listsearchproducts.filter((product: any) => {
            return product.name.toLowerCase().includes(search.toLowerCase())
          })

          if (resFilter.length === 0) {
            res = await POST(
              `/product/productFilterCatalogCupons?order=ASC&page=${page}&take=${take}`,
              {
                name: search,
                isInventoryGreaterThan: 1,
              }
            )
          } else {
            res = {
              data: resFilter,
              meta: {
                hasNextPage: false,
                hasPreviousPage: false,
                itemCount: resFilter.length,
                page: 1,
                pageCount: 1,
                take: 200,
              },
            }
          }
        } else {
          res = await POST(
            `/product/productFilterCatalogCupons?order=ASC&page=${page}&take=${take}&search=${search}`,
            {
              isInventoryGreaterThan: 1,
            }
          )
        }
      }

      setListSearchProducts(res.data)
      setMeta(res.meta)
      setLoadingComp(false)
    } catch (e) {
      setLoadingComp(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Um erro ocorreu ao filtrar os produto, verifique os nome informado!',
      })
    }
  }

  const addList = async (id: any) => {
    const newList = listProducts.map((product) => product)
    const oldList = newList.filter(function (row) {
      return row.id === id
    })
    const selected = listsearchproducts.filter(function (row) {
      return row.id === id
    })
    if (oldList.length === 0) newList.push(selected[0])
    setListProducts(newList)
  }

  const delList = (id: any) => {
    const newList = listProducts.filter((row) => row.id !== id)
    setListProducts(newList)
  }

  async function loadAll() {
    setLoading(true)
    await Promise.all([getSellers(), loadCupom(), getClassification(), getCatalogs()])
    setLoading(false)
  }

  async function loadCupom() {
    try {
      const cupomRes = await GET(`/discount-coupons/getCouponsById/${id}`)

      if (!cupomRes || !cupomRes.success) {
        Swal.fire({
          icon: 'error',
          title: 'Erro.',
          text: 'Erro ao buscar cupom!',
        })
        return
      }

      const cupom = cupomRes.data as CupomData

      setName(cupom.nameCoupom)
      setDescription(cupom.description)

      if (cupom.startDate) {
        setStartDate(new Date(cupom.startDate).toISOString().split('T')[0])
      }

      if (cupom.endDate) {
        setFinishDate(new Date(cupom.endDate).toISOString().split('T')[0])
      }

      if (parseFloat(cupom.valueDiscount) > 0) {
        setType('monetary')
        setValue(parseFloat(cupom.valueDiscount))
      } else {
        setType('percentage')
        setValue(cupom.percentageDiscount)
      }

      setUsageQuantity(cupom.usageQuantity)

      if (cupom.sellerId) {
        setSeller(cupom.sellerId)
        setHasErrorSeller(true)
      }

      if (cupom.idCatalog) {
        setCatalogs(cupom.idCatalog)
        setHasErrorCatalog(true)
      }

      settypeCupom(cupom.typeCupom as CupomType)
      setStatusCupom(cupom.status)

      if ((cupom.typeCupom as CupomType) === 'classification') {
        await getClassificationsOfCupoom(cupom.id)
      }

      if ((cupom.typeCupom as CupomType) === 'product') {
        await getProductsOfCupom(cupom.id)
      }

      if ((cupom.typeCupom as CupomType) === 'cupomDay' && cupom.daysValidity) {
        setDays(
          cupom.daysValidity
            .toString()
            .split('')
            .map((item) => parseInt(item))
        )
      }

      // setCa(cupom.description)
      // setDescription(cupom.description)
    } catch (error) {}
  }

  useEffect(() => {
    loadAll()
  }, [])

  async function getClassificationsOfCupoom(cupomId: Number) {
    try {
      const res = await POST(`/discount-coupons-classification/filterCouponsClassification`, {
        couponId: cupomId,
      })

      if (res && res.success) {
        const data = res.data as {
          id: number
          couponId: number
          classificationId: number
          pluginspaceId: number
          created: string
          updated: string
        }[]
        setClassification(data.map((item) => item.classificationId))
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function getProductsOfCupom(cupomId: Number) {
    try {
      const res = await POST(`/discount-coupons-products/filterCouponsProduct`, {
        couponId: cupomId,
      })
        .then((res) => {
          return res
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro.',
            text: 'Erro ao buscar produtos do cupom!',
          })
          return
        })

      const newProducts = res.data.map((row: any) => {
        return {
          id: row.productId,
          name: row.product.name,
        }
      })

      if (res && res.success) {
        const data = res.data as {
          id: number
          couponId: number
          productId: number
          pluginspaceId: number
          created: string
          updated: string
        }[]
        //setProduct(data.map((item) => item.productId))
        if (newProducts && newProducts.length > 0) {
          const data = newProducts as TypeListProduct[]
          setListProducts(data)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function update() {
    try {
      if (!name || !startDate || !finishDate || !parseFloat(value.toString()) || !typeCupom) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção.',
          text: 'Preencha todos os campos!',
        })
        return
      }

      const cupomBody: DiscountCoupon = {
        id: parseInt(id!),
        nameCoupom: name,
        description: description,
        typeCupom: typeCupom,
        startDate: moment(`${startDate}T00:00:00`).format('YYYY-MM-DDTHH:mm:ss'),
        endDate: moment(`${finishDate}T23:59:59`).format('YYYY-MM-DDTHH:mm:ss'),
        status: statusCupom,
        idCatalog: !catalog ? null : Number(catalog),
        sellerId: !seller ? null : Number(seller),
        usageQuantity: !usageQuantity ? 0 : Number(usageQuantity),
      }

      if (typeCupom === 'classification') {
        if (classification.length === 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Atenção.',
            text: 'Nenhuma classificação foi selecionada!',
          })
          return
        }

        const arraylistClassifications = classification.map((classification) => {
          return Number(classification)
        })

        if (arraylistClassifications) {
          cupomBody.listClassifications = arraylistClassifications
        }
      }

      if (typeCupom === 'product') {
        if (listProducts.length === 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Atenção.',
            text: 'Nenhuma classificacao foi selecionada!',
          })
          return
        }

        const arraylistProducts = listProducts.map((product) => {
          return Number(product.id)
        })

        if (arraylistProducts) {
          cupomBody.listProducts = arraylistProducts
        }
      }

      if ((typeCupom === 'quantitative' || typeCupom === 'periodical') && usageQuantity === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção.',
          text: 'Quantidade Inválida!',
        })
        return
      }

      if (typeCupom === 'cupomDay') {
        if (days.length === 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Atenção.',
            text: 'Nenhum dia foi selecionado!',
          })
          return
        }
        cupomBody.daysValidity = parseInt(days.join(''))
      }
      if (type === 'monetary') {
        cupomBody.valueDiscount = parseFloat(value.toString())
      } else {
        cupomBody.percentageDiscount = parseFloat(value.toString())
      }

      setLoading(true)
      const response = await PATCH('/discount-coupons/updateCoupons', cupomBody)
      setLoading(false)

      if (!response || !response.success) {
        Swal.fire({
          icon: 'error',
          title: 'Erro.',
          text: !response.message ? 'Erro ao atualizar o cupom!' : response.message,
        })

        return
      }

      Swal.fire({
        icon: 'success',
        title: 'Sucesso.',
        text: 'Cupom atualizado com sucesso!',
      }).then(() => navigate('/coupons'))
    } catch (error) {
      let msg = 'Erro ao criar cupom!'
      if (error instanceof Error) {
        msg = error.message
      } else if (typeof error === 'object' && error !== null && 'message' in error) {
        msg = (error as any).message
      } else if (typeof error === 'string') {
        msg = error
      }

      Swal.fire({
        icon: 'error',
        title: 'Erro.',
        text: msg,
      })
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!loading) setValue('0')
  }, [type])

  useEffect(() => {
    if (!loading) {
      setClassification([])
      setDays([])
    }
  }, [typeCupom])

  function alterClassificationArray(value: number) {
    const hasClassification = classification.find((item) => Number(item) === Number(value))

    if (!hasClassification) {
      setClassification([...classification, Number(value)])
    } else {
      setClassification(classification.filter((item) => Number(item) !== Number(value)))
    }
  }

  function alterDaysArray(value: number) {
    const hasClassification = days.find((item) => Number(item) === Number(value))

    if (hasClassification) {
      setDays(days.filter((item) => Number(item) !== Number(value)))
    } else {
      setDays([...days, Number(value)])
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`coupons.title`)}</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(
                    `general.fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes`
                  )}
                </span>
              </h3>
            </div>
            <div className='card-body'>
              <div className='card-body border-bottom'>
                <div className='d-flex flex-row flex-wrap gap-10'>
                  <div style={{flex: 1}}>
                    {/* data de inicio, fim e nome*/}
                    <div className='row'>
                      <div className='col-md-8'>
                        <Input
                          inputAttr={{
                            type: 'default',
                          }}
                          placeholder={i18n.t(`coupons.name_helper`)}
                          label={i18n.t(`coupons.name`)}
                          value={name}
                          change={(value: string) => setName(value)}
                        />

                        <Input
                          inputAttr={{
                            type: 'textarea',
                          }}
                          placeholder={i18n.t(`coupons.description_placeholder`)}
                          label={i18n.t(`coupons.description`)}
                          value={description}
                          maxCaracteres={200}
                          change={(value: string) => setDescription(value)}
                        />
                      </div>
                      <div className='col-md-4 d-flex flex-column gap-5'>
                        <div className='d-flex gap-1'>
                          <Input
                            inputAttr={{type: 'date'}}
                            label={i18n.t(`coupons.dateInit`)}
                            value={startDate}
                            change={setStartDate}
                          />
                          <Input
                            inputAttr={{type: 'date'}}
                            label={i18n.t(`coupons.dateEnd`)}
                            value={finishDate}
                            change={setFinishDate}
                          />
                        </div>
                        <div className='d-flex justify-content-center mt-5'>
                          <Input
                            inputAttr={{type: 'checkbox'}}
                            label={`Status`}
                            checkSwift={true}
                            value={statusCupom}
                            checked={statusCupom}
                            change={(value: boolean) => setStatusCupom(value)}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Tipo de Desconto, Radio Button , valor de desconto e quantidade de utilizacao */}
                    <div className='row '>
                      <div className='col-12'>
                        <div className='d-flex gap-5 align-items-center  col-5'>
                          <div className='mt-10'>
                            <Input
                              inputAttr={{type: 'newRadioAgregador'}}
                              label={'Desconto monetário'}
                              value={'monetary'}
                              checked={type === 'monetary'}
                              change={() => setType('monetary')}
                              name='typeDiscount'
                              paddingLeft={'0px !important'}
                            />
                          </div>
                          <Input
                            inputAttr={{
                              type: `money`,
                            }}
                            value={type === 'monetary' ? value : ''}
                            currency='BRL'
                            locale='pt-BR'
                            change={(value: string) => setValue(value)}
                            label={'Valor de desconto'}
                            disabled={type === 'percentage'}
                          />
                        </div>
                      </div>
                      <div className='col-12'>
                        <div className='col-5 d-flex gap-5 align-items-center '>
                          <div className='mt-10'>
                            <Input
                              inputAttr={{type: 'newRadioAgregador'}}
                              label={'Desconto percentual'}
                              value={'percentage'}
                              checked={type === 'percentage'}
                              change={() => setType('percentage')}
                              name='typeDiscount'
                              paddingLeft={'0px !important'}
                            />
                          </div>
                          <div
                            style={{
                              flex: 1,
                            }}
                          >
                            <Input
                              inputAttr={{
                                type: 'number',
                              }}
                              value={
                                type === 'percentage'
                                  ? parseFloat(value.toString()) != 0
                                    ? value
                                    : ``
                                  : ''
                              }
                              placeholder={`0`}
                              change={(value: string) => setValue(value)}
                              label={'Valor de desconto'}
                              disabled={type === 'monetary'}
                              minNumber={0}
                              maxNumber={100}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/*  Select do tipo do cupom , seller e catalogo*/}

                    <div className='row justify-content-between'>
                      <div className='col-3'>
                        <Input
                          inputAttr={{type: 'select'}}
                          label={i18n.t(`coupons.type`)}
                          disabled
                          value={typeCupom}
                          change={(value: any) => settypeCupom(value)}
                          options={[
                            {value: '', select: 'Selecione um tipo de cupom'},
                            {value: 'classification', select: 'Classificativo'},
                            {value: 'product', select: 'Produto'},
                            //{ value: 'individuality', select: 'Individual' },
                            {value: 'exclusive', select: 'Exclusivo'},
                            {value: 'quantitative', select: 'Quantitativo'},
                            {value: 'periodical', select: 'Periódico'},
                            {value: 'cupomDay', select: 'Do Dia'},
                          ]}
                        />
                      </div>
                      {loginInfo.plugintype !== 'food' && (
                        <>
                          <div className='col-3'>
                            <Input
                              inputAttr={{type: 'select'}}
                              disabled={hasErrorSeller || catalog != 0}
                              label={i18n.t(`coupons.seller`)}
                              value={seller}
                              change={(value: any) => setSeller(value)}
                              options={[
                                {value: 0, select: 'Selecione um vendedor'},
                                ...sellerOptions,
                              ]}
                            />
                          </div>
                          <div className='col-3'>
                            <Input
                              inputAttr={{type: 'select'}}
                              disabled={hasErrorCatalog || seller != 0}
                              label={i18n.t(`coupons.catalog`)}
                              value={catalog}
                              change={(value: any) => setCatalogs(value)}
                              options={[
                                {value: 0, select: 'Selecione um catálogo'},
                                ...catalogsOptions,
                              ]}
                            />
                          </div>
                        </>
                      )}
                    </div>

                    <div className='row'>
                      {typeCupom === 'classification' && (
                        <div className='mt-5 row'>
                          {classificationOptions.map((row, index) => (
                            <div className='col-2'>
                              <Input
                                inputAttr={{type: 'checkbox'}}
                                label={`${row.name}`}
                                value={row.value}
                                /* disabled */
                                checked={
                                  classification.find((item) => item == row.value) ? true : false
                                }
                                change={() => alterClassificationArray(row.value)}
                              />
                            </div>
                          ))}
                        </div>
                      )}

                      {typeCupom === 'product' && (
                        <>
                          <div className='col-md-6'>
                            {loadingComp ? (
                              <Loading />
                            ) : (
                              <Datatable
                                data={listsearchproducts}
                                headers={[
                                  {key: '#ID', value: 'id', type: 'default'},
                                  {key: i18n.t(`smart_order.code`), value: 'code', type: 'default'},
                                  {key: i18n.t(`smart_order.prod`), value: 'name', type: 'default'},
                                  {
                                    key: i18n.t(`general.actions`),
                                    value: 'acoes',
                                    type: '',
                                    noOrder: true,
                                  },
                                ]}
                                options={[
                                  {
                                    icon: 'fas fa-plus',
                                    action: (item) => {
                                      addList(item.id)
                                    },
                                    title: 'adicionar',
                                  },
                                ]}
                                color='primary'
                                meta={meta}
                                onChangeData={async (take, page, search, order) =>
                                  await searchProduct(take, page, search, order)
                                }
                                search
                              />
                            )}
                          </div>

                          <div className='col-md-6'>
                            {listProducts.length > 0 && (
                              <Datatable
                                data={listProducts}
                                headers={[
                                  {key: '#ID', value: 'id', type: 'default'},
                                  {key: i18n.t(`smart_order.code`), value: 'code', type: 'default'},
                                  {key: i18n.t(`smart_order.prod`), value: 'name', type: 'default'},
                                  {
                                    key: i18n.t(`general.actions`),
                                    value: 'acoes',
                                    type: '',
                                    noOrder: true,
                                  },
                                ]}
                                options={[
                                  {
                                    icon: 'fas fa-trash',
                                    action: (item) => {
                                      delList(item.id)
                                    },
                                    title: 'remover',
                                  },
                                ]}
                                color='primary'
                              />
                            )}
                          </div>
                        </>
                      )}

                      {typeCupom === 'quantitative' && (
                        <div className='col-2'>
                          <Input
                            inputAttr={{type: 'number'}}
                            label={i18n.t(`coupons.quantitative`)}
                            value={usageQuantity}
                            change={(value: any) => setUsageQuantity(value)}
                            minNumber={1}
                          />
                        </div>
                      )}
                      {typeCupom === 'cupomDay' && (
                        <div className='mt-5 row'>
                          {[
                            {value: 1, name: 'Domingo'},
                            {value: 2, name: 'Segunda-feira'},
                            {value: 3, name: 'Terça-feira'},
                            {value: 4, name: 'Quarta-feira'},
                            {value: 5, name: 'Quinta-feira'},
                            {value: 6, name: 'Sexta-feira'},
                            {value: 7, name: 'Sábado'},
                          ].map((row, index) => (
                            <div className='col-2'>
                              <Input
                                inputAttr={{type: 'checkbox'}}
                                label={`${row.name}`}
                                value={row.value}
                                checked={days.find((item) => item === row.value) ? true : false}
                                change={() => alterDaysArray(row.value)}
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='d-flex w-100 px-12 pt-8'>
                  <div className='col-6 d-flex justify-content-start'>
                    <Button
                      text={i18n.t(`buttons.back`)}
                      color='info'
                      size='small'
                      horizontalPadding={6}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => navigate(-1)}
                      btnClass='fw-bolder'
                    />
                  </div>
                  <div className='col-6  d-flex justify-content-end'>
                    <Button
                      text={i18n.t(`buttons.save`)}
                      color='primary'
                      size='small'
                      horizontalPadding={6}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => update()}
                      btnClass='fw-bolder'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const EditarCupon: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: 'Produtos', path: 'product_food', isActive: true},
          {title: 'Update', path: '#', isActive: true},
        ]}
      >
        {i18n.t(`coupons.update`)}
      </PageTitle>
      <PageContent />
    </>
  )
}

export {EditarCupon}
